import { TextInput } from "react-admin"

const NumberRangeFilters = [
  <TextInput source='name_Contains' label='resources.filter.nameContains' alwaysOn resettable />,
]

export default NumberRangeFilters